import { render, staticRenderFns } from "./CoreProgramCampaignSettingsStatusList.vue?vue&type=template&id=f0ad8d6c&"
import script from "./CoreProgramCampaignSettingsStatusList.vue?vue&type=script&lang=js&"
export * from "./CoreProgramCampaignSettingsStatusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports